export const getUserInitials = (
  firstName: string | undefined | null,
  lastName: string | undefined | null,
) => {
  const initials = `${firstName?.slice(0, 1) ?? ''}${
    lastName?.slice(0, 1) ?? ''
  }`;
  return initials.length > 0 ? initials : '';
};
